export default "__VITE_ASSET__LilsuD4$__"